import {
  CREATE_SAFESCARF_PRODUCT_FULFILLED,
  FETCH_SAFESCARF_PRODUCTS_FULFILLED,
  UPDATE_SAFESCARF_PRODUCT_FULFILLED,
  DELETE_SAFESCARF_PRODUCT_FULFILLED,
} from './actions';

import type { Product } from '@/types/productTypes';

export interface SafeScarfProductsAction {
  type: string;
  payload?: Product | Product[] | string;
}

const productsReducer = (state: Product[] = [], action: SafeScarfProductsAction): Product[] => {
  switch (action.type) {
    case CREATE_SAFESCARF_PRODUCT_FULFILLED:
      return [...state, action.payload as Product];
    case FETCH_SAFESCARF_PRODUCTS_FULFILLED:
      return action.payload as Product[];
    case UPDATE_SAFESCARF_PRODUCT_FULFILLED: {
      const updated = action.payload as Product;
      return state.map(product => {
        if (product.id === updated.id) {
          return updated;
        }
        return product;
      });
    }
    case DELETE_SAFESCARF_PRODUCT_FULFILLED:
      return state.filter(product => product.id !== (action.payload as string));
    default:
      return state;
  }
};

export { productsReducer };
